import * as React from 'react';
import {
    List,
    DatagridConfigurable,
    TextField,
    DateField,
    DateInput,
    TopToolbar,
    ExportButton,
    SelectColumnsButton,
    ReferenceInput,
    FilterButton,
    CreateButton,
    useRecordContext,
} from 'react-admin';

const ListActions = () => (
    <TopToolbar>
        {/*<FilterButton />*/}
        <CreateButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
);

interface CustomLastUsedFieldProps {
    source: string;
}

const LastUsedField: React.FC<CustomLastUsedFieldProps> = ({ source }) => {
    const record = useRecordContext();
    if (!record) return null;

    const value = record[source];
    if (value === 0) {
        return <span>Not used yet</span>;
    }

    const date = new Date(value * 1000);
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };

    return <span>{date.toLocaleString('en-US', options)}</span>;
};

const APIKeysList = () => (
    <div style={{ marginTop: '20px' }}>
        <List
            // filters={listFilters}
            perPage={25}
            sort={{ field: 'date', order: 'DESC' }}
            actions={<ListActions />}
        >
            <DatagridConfigurable
                rowClick="expand"
                // expand={<InvoiceShow />}
                sx={{
                    '& .column-customer_id': {
                        display: { xs: 'none', md: 'table-cell' },
                    },
                    '& .column-total_ex_taxes': {
                        display: { xs: 'none', md: 'table-cell' },
                    },
                    '& .column-delivery_fees': {
                        display: { xs: 'none', md: 'table-cell' },
                    },
                    '& .column-taxes': {
                        display: { xs: 'none', md: 'table-cell' },
                    },
                }}
            >
                <TextField source="id" />
                <TextField source="description" />
                <DateField
                    source="dateCreated"
                    showTime
                    options={{
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                    }}
                    locales="en-US"
                    transform={v => new Date(v * 1000)}
                />
                <LastUsedField source="lastUsed" />
                <TextField source="prefix" />
            </DatagridConfigurable>
        </List>
    </div>
);

export default APIKeysList;
